import { render, staticRenderFns } from "./ConfigurationView.vue?vue&type=template&id=91d3501e&scoped=true"
import script from "./ConfigurationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationView.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationView.vue?vue&type=style&index=0&id=91d3501e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d3501e",
  null
  
)

export default component.exports